document.querySelectorAll('[data-light-preview]').forEach(preview => {
  const button = preview.querySelector('[data-light-toggle]');
  button.addEventListener('click', () => {
    const lit = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(lit));
    preview.classList.toggle('is-lit', lit);
    preview.querySelector('[data-light-stage]').setAttribute('aria-label', lit ? 'Sample Hidden Photo Keychain with its photo revealed by light' : 'Sample Hidden Photo Keychain with the light off');
    preview.querySelector('[data-light-label]').textContent = lit ? 'Turn the light off' : 'Turn the light on';
    preview.querySelector('[data-light-status]').textContent = lit ? 'The sample photo is revealed.' : 'Tap the light to reveal the photo.';
  });
});
